var map = {
	"app/modules/company-user/company-user.module": [
		"./src/app/modules/company-user/company-user.module.ts",
		"common",
		"company-user.module"
	],
	"app/modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"app/modules/extension-lot/extension-lot.module": [
		"./src/app/modules/extension-lot/extension-lot.module.ts",
		"common",
		"extension-lot.module"
	],
	"app/modules/extension-stamp/extension-stamp.module": [
		"./src/app/modules/extension-stamp/extension-stamp.module.ts",
		"common",
		"extension-stamp.module"
	],
	"app/modules/extension-verification/extension-verification.module": [
		"./src/app/modules/extension-verification/extension-verification.module.ts",
		"common",
		"extension-verification.module"
	],
	"app/modules/extension/extension.module": [
		"./src/app/modules/extension/extension.module.ts",
		"common",
		"extension.module"
	],
	"app/modules/factory/factory.module": [
		"./src/app/modules/factory/factory.module.ts",
		"common",
		"factory.module"
	],
	"app/modules/gift-category/gift-category.module": [
		"./src/app/modules/gift-category/gift-category.module.ts",
		"common",
		"gift-category.module"
	],
	"app/modules/gift/gift.module": [
		"./src/app/modules/gift/gift.module.ts",
		"common",
		"gift.module"
	],
	"app/modules/manufacturer/manufacturer.module": [
		"./src/app/modules/manufacturer/manufacturer.module.ts",
		"common",
		"manufacturer.module"
	],
	"app/modules/page/page.module": [
		"./src/app/modules/page/page.module.ts",
		"common",
		"page.module"
	],
	"app/modules/point-accumulation/point-accumulation.module": [
		"./src/app/modules/point-accumulation/point-accumulation.module.ts",
		"common",
		"point-accumulation.module"
	],
	"app/modules/point-cycle/point-cycle.module": [
		"./src/app/modules/point-cycle/point-cycle.module.ts",
		"common",
		"point-cycle.module"
	],
	"app/modules/point-spending/point-spending.module": [
		"./src/app/modules/point-spending/point-spending.module.ts",
		"common",
		"point-spending.module"
	],
	"app/modules/product/product.module": [
		"./src/app/modules/product/product.module.ts",
		"common",
		"product.module"
	],
	"app/modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"app/modules/report/report.module": [
		"./src/app/modules/report/report.module.ts",
		"common",
		"report.module"
	],
	"app/modules/stamp-list/stamp-list.module": [
		"./src/app/modules/stamp-list/stamp-list.module.ts",
		"common",
		"stamp-list.module"
	],
	"app/modules/stamplot-list/stamplot-list.module": [
		"./src/app/modules/stamplot-list/stamplot-list.module.ts",
		"common",
		"stamplot-list.module"
	],
	"app/modules/stamplot/stamplot.module": [
		"./src/app/modules/stamplot/stamplot.module.ts",
		"common",
		"stamplot.module"
	],
	"app/modules/stamps/stamp.module": [
		"./src/app/modules/stamps/stamp.module.ts",
		"common",
		"stamp.module"
	],
	"app/modules/verification-report/verification-report.module": [
		"./src/app/modules/verification-report/verification-report.module.ts",
		"common",
		"verification-report.module"
	],
	"app/modules/warranty/warranty.module": [
		"./src/app/modules/warranty/warranty.module.ts",
		"common",
		"warranty.module"
	],
	"app/pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"home.module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"common",
		"login.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main